import {DateTime} from 'luxon';

export const initializeApp = async () => {
	injectGlobalDebugValues();
};

const injectGlobalDebugValues = () => {
	// For debugging
	(window as any).DateTime = DateTime;
};
